/* eslint-disable no-undef */
export default function initPbJs() {
  pbjs = pbjs || {};
  pbjs.que = pbjs.que || [];
  // pbjs.removeAdUnit();
}
